// extracted by mini-css-extract-plugin
export default {"videos":"VideoList_videos__9HkKI"};